import { ReservationService } from '../../services/reservation.service';
import { Component, OnInit, Input } from '@angular/core';
import { Reservation } from '../../models/reservation.model';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'create-reservation',
  templateUrl: './create-reservation.component.html',
  styleUrls: ['./create-reservation.component.scss'],
})
export class CreateReservationComponent implements OnInit {

  @Input() mode: string;
  reservation: Reservation
  reservationDate: string

  constructor(private reservationService: ReservationService, public util: UtilService) { }

  ngOnInit() {
    this.reservationDate = '' + new Date()
    this.reservation = new Reservation()

    if (this.mode == "owner") {
      this.reservation.desc = "Reservierung wurde durch das Lokal erfasst"
      this.reservation.confirmed = true
    }
  }

  sendReservationRequest() {
    console.log(new Date(this.reservationDate))
    if (this.reservation.amount <= 0 || !this.hasText(this.reservation.name) || !this.hasText(this.reservation.mail) || !this.hasText(this.reservation.phone)) {
      this.util.presentToast("Bitte fülle alle Felder aus ('Bemerkung' ausgenommen)", 3000, 'toast-warning')
      return
    }

    this.reservation.date = new Date(this.reservationDate).getTime()
    
    if ((this.reservation.date + 10800000) < new Date().getTime()) {
      this.util.presentToast("Reserviungszeit muss in der Zukunft liegen", 3000, 'toast-warning') //bzw. aktuell -3h rückwirkend
      return
    }

    this.reservationService.requestReservation(this.reservation)
    this.util.reservationUI = "overview"
    this.util.presentToast("Ihre Reservierung wurde gesendet. Sie wird schnellstmöglich bearbeitet", 3500, 'toast-success')
    this.reservationDate = '' + new Date()
    this.reservation = new Reservation()
  }

  hasText(text: string): boolean {
    return (text && text.length > 0)
  }

}
